import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  light?: boolean;
}

export default function Breadcrumb({ items, light = false }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs">
      <Link
        to="/"
        className={`cursor-pointer transition-colors ${light ? 'text-background-300/80 hover:text-accent-300' : 'text-foreground-400 hover:text-primary-600'}`}
      >
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className={`ri-arrow-right-s-line ${light ? 'text-background-400/60' : 'text-foreground-300'}`} />
          {item.path ? (
            <Link
              to={item.path}
              className={`cursor-pointer transition-colors ${light ? 'text-background-300/80 hover:text-accent-300' : 'text-foreground-400 hover:text-primary-600'}`}
            >
              {item.label}
            </Link>
          ) : (
            <span className={light ? 'text-background-100' : 'text-foreground-700'} aria-current="page">
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}